import { THEMES } from '@dfl/mui-react-common';
import { grey } from '@mui/material/colors';
import { createTheme, lighten, Theme } from '@mui/material';
import { components } from './components';
import themeConfig from './branding';

export const RED = '#F84842';
export const GREEN = '#65BE46';
export const GRAY = '#646D82';
export const BLUE = '#37AEFF';
export const WARNING = '#FDA20A';

declare module '@mui/material/styles' {
  interface Palette {
    neutral: Palette['primary'];
    formLabel: string;
    link: string;
  }

  interface PaletteOptions {
    neutral?: PaletteOptions['primary'];
  }
}

// Extend color prop on components
declare module '@mui/material/Chip' {
  export interface ChipPropsColorOverrides {
    opacity: true;
  }
}
// #fdfdfd59

export const common = createTheme({
  components: {
    ...components,
    MuiAvatar: {
      styleOverrides: {
        root: {
          '.MuiAvatar-img': {
            objectPosition: 'top',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: ({ theme: { palette } }) => ({
          background: palette.mode === 'light' ? lighten(palette.primary.light, 0.8) : grey['800'],

          '.MuiTableCell-root,.MuiTableSortLabel-root': {
            // color: theme.palette.primary.main,
          },
        }),
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: ({ theme }: { theme: Theme }) => ({
          '&.row-warning': {
            background: `${theme.palette.warning.main}30`,
          },
          '&.row-error': {
            background: `${theme.palette.error.main}30`,
          },
          '&.row-success': {
            background: `${theme.palette.success.main}30`,
          },
        }),
      },
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          '.MuiButtonBase-root': {
            minWidth: 20,
            textTransform: 'none',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        ':root, :before, :after': {
          '--primary-color': `${theme.palette.primary.main} !important`,
        },
        '.truncate': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        '.phone-input-large, .phone-input-middle': {
          '.react-tel-input': {
            'input.form-control': {
              padding: '16px 14px 16px 58px!important',
            },
          },
        },
        '.phone-input-small': {
          '.react-tel-input': {
            'input.form-control': {
              padding: '9px 14px 7px 58px!important',
            },
          },
        },
        '.react-tel-input': {
          '.special-label': {
            fontSize: '11px!important',
          },
        },
      }),
    },
  },
  typography: {
    h1: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: 1.6,
      letterSpacing: '0.0075em',
    },
    h2: {
      fontSize: 18,
      fontWeight: 500,
    },
    h3: {
      fontSize: 18,
      fontWeight: 500,
    },
    h4: {
      fontSize: 16,
      fontWeight: 500,
    },
    body1: {
      fontSize: 14,
    },
    h6: {
      fontSize: 13,
      fontWeight: 500,
      lineHeight: 1.5,
      whiteSpace: 'normal',
      textTransform: 'none',
    },
  },
});

const LIGHT = {
  ...common,
  palette: {
    mode: THEMES.LIGHT,
    sidebar: {
      background: '#fff',
      color: 'secondary.main',
      activeColor: 'secondary.main',
      active: 'primary.light',
    },
    ...themeConfig.theme,
  },
};

const DARK = {
  ...common,
  palette: {
    mode: THEMES.DARK,
    sidebar: '#111827',
    spaceSelector: '#222b36',
    background: {
      default: '#1e2732',
      paper: '#222b36',
    },
    primary: {
      main: '#90caf9',
      light: '#363e48',
    },
    opacity: {
      main: '#fdfdfd59',
      contrastText: '#fff',
    },
    secondary: {
      ...grey,
      main: grey['400'],
      light: grey['800'],
    },
    neutral: {
      main: grey['800'],
    },
    formLabel: '#fff',
    link: '#8ab4f8',
  },
};

export const THEME_SETTING = {
  [THEMES.LIGHT]: LIGHT,
  [THEMES.DARK]: DARK,
};
